const initialState = {}

const sideModule = (state = initialState, data) => {
    if (data.action === 'SET_TIMELINE' && data.value) {
        return {
            ...state,
            ...data.value,
        }
    } else {
        return state
    }
};

export default sideModule;